<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M20.25 3.75H21V3H20.25V3.75ZM20.25 20.25V21H21V20.25H20.25ZM3.75 20.25H3V21H3.75V20.25ZM3.75 3.75V3H3V3.75H3.75ZM15.5303 9.53033L16.0607 9L15 7.93934L14.4697 8.46967L15.5303 9.53033ZM8.46967 14.4697L7.93934 15L9 16.0607L9.53033 15.5303L8.46967 14.4697ZM14.4697 15.5303L15 16.0607L16.0607 15L15.5303 14.4697L14.4697 15.5303ZM9.53033 8.46967L9 7.93934L7.93934 9L8.46967 9.53033L9.53033 8.46967ZM19.5 3.75V20.25H21V3.75H19.5ZM20.25 19.5H3.75V21H20.25V19.5ZM4.5 20.25V3.75H3V20.25H4.5ZM3.75 4.5H20.25V3H3.75V4.5ZM14.4697 8.46967L8.46967 14.4697L9.53033 15.5303L15.5303 9.53033L14.4697 8.46967ZM15.5303 14.4697L9.53033 8.46967L8.46967 9.53033L14.4697 15.5303L15.5303 14.4697Z"
    fill="currentColor"
  />
</svg>
